import { NgModule }                      from '@angular/core';
import { Routes, RouterModule }          from '@angular/router';

import { EditionsComponent }             from './editions.component';

const routes: Routes = [{
  path: '',
  component: EditionsComponent,
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class EditionsRoutingModule { }



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/editions/editions-routing.module.ts